import React from 'react';

import Menu from '@mui/material/Menu';
import IconButton from '@mui/material/IconButton';

import MoreHorizIcon from '@mui/icons-material/MoreHoriz';

import TracklogMenu from 'ff/debrief/components/menu/TracklogMenu';

interface Props {}

const Kebab: React.FC<Props> = props => {
    const anchorElRef = React.useRef(null);
    const [isOpen, setIsOpen] = React.useState(false);

    const handleKebabClick = () => {
        setIsOpen(!isOpen);
    };

    const handleClose = () => {
        setIsOpen(false);
    };

    return (
        <div>
            <IconButton
                ref={anchorElRef}
                color="secondary"
                onClick={handleKebabClick}
            >
                <MoreHorizIcon sx={{ color: '#000000' }} />
            </IconButton>
            <Menu
                anchorEl={anchorElRef.current}
                onClose={handleClose}
                open={isOpen}
                anchorOrigin={{
                    vertical: 'top',
                    horizontal: 'right',
                }}
                transformOrigin={{
                    vertical: 'bottom',
                    horizontal: 'right',
                }}
                sx={{ mt: '5px' }}
            >
                <TracklogMenu onMenuItemClick={handleClose}></TracklogMenu>
            </Menu>
        </div>
    );
};

export default Kebab;
